module.exports = __webpack_public_path__ + "media/mike3.9cc8ebf0.mp3";